import { mapRecord, memo, projectFieldWithEnv } from '@morphic-ts/common/es6/utils';
import { getStructEq } from 'fp-ts/Eq';
import { eqApplyConfig } from '../config';
import { EqType, EqURI } from '../hkt';
const asPartialEq = (x) => x;
/**
 *  @since 0.0.1
 */
export const eqOrUndefined = (eq) => ({
    equals: (x, y) => (x === undefined ? y === undefined : y !== undefined && eq.equals(x, y))
});
/**
 *  @since 0.0.1
 */
export const eqObjectInterpreter = memo(() => ({
    _F: EqURI,
    interface: (props, _name, config) => env => {
        const equals = projectFieldWithEnv(props, env)('eq');
        return new EqType(eqApplyConfig(config)(getStructEq(equals), env, { equals }));
    },
    // relies on Eq<A> whereas we need Eq<Partial<A>> (but works - covered by tests)
    partial: (props, _name, config) => env => {
        const equals = mapRecord(projectFieldWithEnv(props, env)('eq'), eqOrUndefined);
        return new EqType(eqApplyConfig(config)(asPartialEq(getStructEq(equals)), env, { equals }));
    },
    both: (props, pprops, _name, config) => env => {
        const equalsPartial = mapRecord(projectFieldWithEnv(pprops, env)('eq'), eqOrUndefined);
        const equals = projectFieldWithEnv(props, env)('eq');
        return new EqType(eqApplyConfig(config)(getStructEq(Object.assign(Object.assign({}, equalsPartial), equals)), env, { equalsPartial, equals }));
    }
}));
